import { DEVELOPMENT_SOURCE_METRIC } from 'constants/sources';

export const EXCEL_COLORS = {
    BLUE_HEADER: '0FB3FF',
    GRAY_HEADER: 'F2F2F2',
    DARK_GRAY: 'BFBFBF',
    WHITE: 'FFFFFF',
    BLACK: '000000',
};

export const EXCEL_NUM_FORMATS = {
    CURRENCY: '"$"#,##0',
    CURRENCY_CENTS: '"$"#,##0.00',
    PERCENT: '0.00%',
    NUMBER: '#,##0',
    NUMBER_DECIMAL: '#,##0.00',
    MULTIPLE: '0.00"x"',
};

export const EXCEL_SHEET_NAMES = {
    BUILDING_INFO: 'Building Info & Assumptions',
    SOURCES_USES: 'Sources & Uses',
    CASH_FLOW: 'Cash Flow Schedule',
    DISPOSITION: 'Disposition',
    RETURNS_SUMMARY: 'Returns Summary',
} as const;

export const SOURCE_METRIC_LABELS: Record<string, string> = {
    [DEVELOPMENT_SOURCE_METRIC.LTC]: 'LTC',
    [DEVELOPMENT_SOURCE_METRIC.LTV]: 'LTV',
    [DEVELOPMENT_SOURCE_METRIC.DEBT_YIELD]: 'Debt Yield',
};
